// pathname: /v1/company/check-identifier/${identifier}
// ************************************************************************************************
import {
  ICompanyCheckIdentifier,
  useSwrMutationApi,
} from 'src/hooks/useSwrApi';

/**
 * @description SWR mutation: get company details by cui.
 * the payload.
 * @param locale
 * @param identifier
 * @param individual
 */
export const useSwrMutationCheckIdentifier = (locale = 'ro', identifier = '', individual?: boolean) => {
  const individualQuery = typeof individual === 'boolean' ? `?individual=${individual ? 1 : 0}` : '';
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ICompanyCheckIdentifier, object>({
    url: `/v1/company/check-identifier/${identifier}${individualQuery}`,
    locale,
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
